<template>
    <section class="ds-page-header">
        <div class="ds-container ds-page-header__container">
            <div class="ds-page-header__logo">
                <slot name="logo" :theme="theme"></slot>
            </div>
            <div class="ds-page-header__nav">
                <slot name="navigation" :theme="theme"></slot>
            </div>
        </div>
    </section>
</template>

<script>
import { theme } from '../../utils/mixins';
/**
 * Page header component
 *
 * `@mixins theme`
 *
 * `@property {String} theme`

 * Usage
 * @example
 * ```js
 * import { DsPageHeader } from '@/layout'
 *
 * export default {
 *   components: { DsPageHeader },
 *   template: `<div>
 *     <DsPageHeader>
 *       <template #logo>
 *         ...
 *       </template>
 *       <template #navigation>
 *         ...
 *       </template>
 *     </DsPageHeader>
 *  `</div>
 * }
 * ```
 */
export default {
    name: 'DsPageHeader',
    mixins: [theme],
    props: {
    /**
     * Screen size based on breakpoints
     */
        screen: { type: String, required: true }
    },
    provide () {
        return {
            trackingData: { 'component-name': this.$options.name }
        };
    },
};
</script>

<style lang="scss" scoped>
@import '../../foundation/tokens/variables';
@import '../../foundation/mixins/mixins';

.ds-page-header {
    height: 100%;

    &__container {
        align-items: center;
        display: flex;
        height: $height-header;
    }

    &__logo {
        align-items: center;
        display: flex;
        height: 100%;
        z-index: $z-index-2;
    }

    &__nav {
        height: 100%;
        position: relative;
        width: 100%;
    }
}
</style>
